import ZTooltip from "@atoms/ZTooltip";
import ZTypography from "@atoms/ZTypography";
import useMobileView from "@/Hooks/useMobileView";
import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import ZAppHeader from "../AppHeader";
import ZBackButton from "../AppHeader/ZBackButton";
import "./index.less";
import {
	IContentProps,
	IHeaderCenterProps,
	IHeaderLeftProps,
	IHeaderRightProps,
	TDashboard,
	THeader
} from "./interface";

const { ZText } = ZTypography;

const HeaderLeft: React.FC<IHeaderLeftProps> = ({
	isBackButton = true,
	onBackButtonClick,
	title = "",
	children,
	customBackButton
}) => {
	const isMobileView = useMobileView();

	return (
		<div className="z-left-side-content flex items-center h-full">
			{isBackButton && (
				<ZBackButton
					isMobileView={isMobileView}
					onClick={onBackButtonClick}
				/>
			)}
			{customBackButton}
			{title && (
				<ZTooltip placement={"bottomLeft"} title={title}>
					<ZText className=" z-page-header-title items-center truncate">
						{title}
					</ZText>
				</ZTooltip>
			)}
			{children}
		</div>
	);
};

const HeaderCenter: React.FC<IHeaderCenterProps> = ({
	isGlobalSearch = true,
	globalSearchComponent,
	align = "right"
}) => {
	const isMobileView = useMobileView();
	const marginClass = useMemo(() => {
		if (align === "center") return "mx-auto";
		else if (align === "left") return "mr-auto";
		else return "ml-auto";
	}, []);
	return (
		<div className={`flex ${marginClass} items-center`}>
			{isGlobalSearch && !isMobileView && <>{globalSearchComponent}</>}
		</div>
	);
};

const HeaderRight: React.FC<IHeaderRightProps> = ({
	mobileModuleSelectComponent,
	mobileViewEntityDropdownRoutes,
	children
}) => {
	const isMobileView = useMobileView();
	const location = useLocation();

	const showEntityDropDown = () => {
		return mobileViewEntityDropdownRoutes?.includes(location.pathname);
	};

	return (
		<div className="flex items-center">
			{!isMobileView && children}
			{isMobileView && showEntityDropDown() && (
				<>{mobileModuleSelectComponent}</>
			)}
		</div>
	);
};

const Header: THeader = props => (
	<ZAppHeader {...props}>{props.children}</ZAppHeader>
);

Header.Left = HeaderLeft;
Header.Center = HeaderCenter;
Header.Right = HeaderRight;

const ZContent: React.FC<IContentProps> = React.forwardRef(
	(
		{
			isSideMenuAvailable = true,
			isFullScreen = false,
			children,
			isBannerOpen,
			className = ""
		},
		ref
	) => {
		const isMobileView = useMobileView();

		return (
			<div
				ref={ref}
				className={`main-content ${
					isBannerOpen ? "banner-open" : ""
				} ${className}`}
			>
				<div
					className={`background ${
						isFullScreen ? "" : "background-not-full-screen"
					} ${
						isMobileView
							? "pl-2"
							: isSideMenuAvailable
							? ""
							: "pl-2"
					}`}
				>
					<div
						className={`content ${
							isFullScreen ? "" : "p-4"
						} rounded-md overflow-y-auto`}
					>
						{children}
					</div>
				</div>
			</div>
		);
	}
);

const Dashboard: TDashboard = props => (
	<React.Fragment>{props.children}</React.Fragment>
);

Dashboard.Header = Header;
Dashboard.Content = ZContent;

export default Dashboard;
